<template>
  <div class="col-lg-12 p-0">
    <label :for="inputConfig.id">{{ inputConfig.name }}</label>
    <input :id="inputConfig.id" class="form-control" v-model="form[inputConfig.id]"
           ref="general_input_1"
           @input="refreshComponent"
           :placeholder="inputConfig.placeholder" :required="inputConfig.required" :type="inputConfig.type"
    />
  </div>
</template>

<script>

export default {
  name: "GeneralInput1",
  props: {
    inputConfig: {},
    form: {}
  },
  methods: {
    refreshComponent() {
      this.$forceUpdate()
      this.$emit('refresh', true)
    }
  },
  mounted() {
    let input = this.$refs.general_input_1
    let pattern = this.inputConfig.regex
    if (pattern != '') {
      input.pattern = pattern
    }
  }
}
</script>

<style scoped>

</style>